import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Coffee Beans",
        price: 38,
        disprice: 28,
        stock: 15,
        content: "Savor every sip with our carefully selected coffee beans. Grown in the lush highlands, our beans deliver a perfect balance of body, acidity, and flavor. Ideal for mornings, afternoons, or special moments, our beans promise a freshly brewed cup filled with authentic taste and rich aroma.",
        description: "Our coffee beans are sourced from renowned plantations known for their quality and sustainability. Expertly roasted to capture the beans’ natural essence, they offer notes of chocolate, fruit, and a hint of spice. Perfect for French press, espresso, or drip methods, these beans guarantee a smooth, full-flavored experience that coffee lovers will cherish.",
        category: ["Coffee Beans", "Coffee Equipment"],
        tags: ["Beans", "Blend", "Espresso"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Origin", content: "Brazil, Kenya, Honduras" },
            { id: 2, title: "Roast Level", content: "Medium Roast" },
            { id: 3, title: "Blend Type", content: "Single-Origin" },
            { id: 4, title: "Weight", content: "500g" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Sophie Lane",
                date: "Mar 02, 2024",
                rating: 5,
                content: "Incredible beans! Fresh, aromatic, and absolutely delicious. My morning brew has never tasted this good."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Daniel Reed",
                date: "Mar 04, 2024",
                rating: 5,
                content: "High-quality beans with a smooth and flavorful profile. Will definitely buy again for my home brewing."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Coffee Set",
        price: 85,
        disprice: 70,
        stock: 8,
        content: "Elevate your coffee moments with our premium Coffee Set. Carefully curated for true coffee lovers, this set includes a selection of finely roasted beans and stylish brewing accessories. Whether it's a cozy morning or an afternoon gathering, this set brings luxury and flavor to every cup.",
        description: "Our Coffee Set is designed to offer a complete brewing experience. Featuring high-grade beans sourced from elite plantations and elegant brewing tools, it ensures rich flavors and easy preparation. Ideal for gifting or personal use, this set suits both beginners and connoisseurs, making every coffee ritual special and memorable.",
        category: ["Coffee Set", "Coffee Accessories"],
        tags: ["Set", "Mug", "Blend"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Includes", content: "Coffee Beans, French Press, Measuring Spoon" },
            { id: 2, title: "Bean Origin", content: "Ethiopia, Costa Rica" },
            { id: 3, title: "Roast Level", content: "Medium Roast" },
            { id: 4, title: "Weight", content: "2x 250g Bean Packs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Olivia Hart",
                date: "Mar 10, 2024",
                rating: 5,
                content: "Absolutely love this set! It has everything I need to brew delicious coffee at home. Perfect for my weekend mornings."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Liam Brooks",
                date: "Mar 11, 2024",
                rating: 5,
                content: "The beans are excellent and the brewing tools are high quality. Great set for any coffee enthusiast or as a gift!"
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Portafilter",
        price: 55,
        disprice: 42,
        stock: 12,
        content: "Upgrade your espresso game with our precision Portafilter. Built from durable, high-grade materials, it ensures a perfect fit and consistent extraction. Whether you’re a seasoned barista or a passionate home brewer, our portafilter delivers a professional-level brewing experience every time.",
        description: "Our premium Portafilter is crafted for durability and precision. Featuring a stainless steel basket and an ergonomic handle, it provides excellent heat retention and comfortable grip. Compatible with most espresso machines, it’s the perfect tool to achieve rich, balanced, and aromatic espresso shots with ease.",
        category: ["Coffee Maker", "Coffee Equipment"],
        tags: ["Portafilter", "Espresso", "Set"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Stainless Steel & Wood" },
            { id: 2, title: "Compatibility", content: "58mm Standard Size" },
            { id: 3, title: "Handle Type", content: "Ergonomic Grip" },
            { id: 4, title: "Weight", content: "450g" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Emily Ford",
                date: "Mar 18, 2024",
                rating: 5,
                content: "Solid build and perfect fit! It made a huge difference in my espresso quality. Highly recommend for serious coffee lovers."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Noah Grant",
                date: "Mar 19, 2024",
                rating: 5,
                content: "Excellent portafilter — sturdy, well-made, and easy to handle. My espresso shots are more consistent now."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Moka",
        price: 45,
        disprice: 35,
        stock: 0,
        content: "Experience rich, authentic coffee with our classic Moka pot. Designed for stovetop brewing, it offers a full-bodied flavor that captures the essence of traditional Italian coffee. Whether you’re brewing a morning espresso or an afternoon pick-me-up, the Moka pot delivers a bold, satisfying cup every time.",
        description: "Crafted from durable aluminum with an easy-grip handle, our Moka pot combines tradition and practicality. It brews coffee by passing hot water through finely ground coffee under pressure, producing a strong, espresso-like drink. Perfect for everyday use, it's a must-have for coffee lovers seeking quality and simplicity at home.",
        category: ["Coffee Maker", "Coffee Equipment"],
        tags: ["Moka", "Set", "Espresso"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Aluminum Alloy" },
            { id: 2, title: "Capacity", content: "6-Cup (300ml)" },
            { id: 3, title: "Handle Type", content: "Heat-Resistant" },
            { id: 4, title: "Compatible With", content: "Gas, Electric Stovetops" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Sophia Blake",
                date: "Mar 25, 2024",
                rating: 5,
                content: "Absolutely love my Moka pot! It's simple to use and the coffee it makes is strong, flavorful, and authentic."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Ethan Hill",
                date: "Mar 26, 2024",
                rating: 5,
                content: "Fantastic quality! Sturdy build and brews a rich coffee every time. I use it daily and couldn't be happier."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Espresso Maker",
        price: 220,
        disprice: 180,
        stock: 4,
        content: "Brew café-quality espresso at home with our advanced Espresso Maker. Designed for coffee enthusiasts, it offers precision control, rich crema production, and consistent results. Whether you're crafting a strong morning shot or an indulgent latte, this machine brings professional brewing right to your kitchen.",
        description: "Our Espresso Maker combines modern technology with classic brewing methods. Featuring a high-pressure pump, stainless steel construction, and easy-to-use controls, it delivers exceptional espresso with every use. Perfect for beginners and experts alike, it turns every cup into a rich, aromatic masterpiece with minimal effort.",
        category: ["Coffee Maker", "Coffee Equipment"],
        tags: ["Espresso", "Maker", "Set"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Pressure", content: "15-Bar Pump System" },
            { id: 2, title: "Material", content: "Stainless Steel Body" },
            { id: 3, title: "Capacity", content: "1.5L Water Tank" },
            { id: 4, title: "Features", content: "Steam Wand, Cup Warmer" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Chloe Reed",
                date: "Apr 02, 2024",
                rating: 5,
                content: "This espresso maker is amazing! Easy to use and the coffee comes out rich and flavorful every time. Totally worth it."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "James Ellis",
                date: "Apr 03, 2024",
                rating: 5,
                content: "Impressed with the quality and performance. It feels sturdy and makes perfect espresso shots without much hassle."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Mug",
        price: 18,
        disprice: 14,
        stock: 20,
        content: "Start your day with style using our premium Coffee Mug. Crafted from high-quality ceramic, this mug is perfect for your morning coffee, tea, or hot chocolate. Its sleek design and comfortable handle make every sip a pleasure, whether you’re at home or at the office.",
        description: "Our Coffee Mug features a modern, minimalist design that complements any kitchen or workspace. Made from durable ceramic, it retains heat, keeping your drink warm for longer. The mug’s smooth finish and ergonomic handle make it easy to hold, while its classic look adds a touch of elegance to any beverage experience.",
        category: ["Coffee Accessories", "Coffee Equipment"],
        tags: ["Mug", "Set", "Instant"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Quality Ceramic" },
            { id: 2, title: "Capacity", content: "350ml" },
            { id: 3, title: "Design", content: "Modern Minimalist" },
            { id: 4, title: "Microwave Safe", content: "Yes" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Sophia Lee",
                date: "Apr 07, 2024",
                rating: 5,
                content: "Love this mug! The design is simple yet elegant, and it holds the perfect amount of coffee. It’s my go-to mug now."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Daniel Smith",
                date: "Apr 08, 2024",
                rating: 5,
                content: "Great quality mug. It’s sturdy, easy to clean, and keeps my coffee hot longer. Highly recommend it."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Instant Coffee",
        price: 25,
        disprice: 20,
        stock: 18,
        content: "Enjoy a quick, flavorful cup of coffee with our Instant Coffee. Made from premium, freeze-dried beans, it delivers a rich, aromatic coffee experience in seconds. Whether you're at home, at the office, or traveling, our Instant Coffee provides the perfect solution for coffee lovers in a hurry.",
        description: "Our Instant Coffee is crafted from 100% Arabica beans, expertly freeze-dried to preserve the rich flavor and aroma. It's incredibly easy to prepare—just add hot water, and you’re ready to enjoy a smooth, satisfying cup. Perfect for those who need quality coffee with no hassle, anytime, anywhere.",
        category: ["Coffee Beans", "Coffee Set"],
        tags: ["Instant", "Beans", "Blend"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Beans Type", content: "100% Arabica" },
            { id: 2, title: "Serving Size", content: "100g" },
            { id: 3, title: "Preparation", content: "Add Hot Water" },
            { id: 4, title: "Flavor Profile", content: "Smooth & Balanced" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Grace Moore",
                date: "Apr 12, 2024",
                rating: 5,
                content: "Best instant coffee I’ve ever tried! It’s smooth, flavorful, and so easy to make. I carry it with me everywhere."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Liam Johnson",
                date: "Apr 13, 2024",
                rating: 5,
                content: "I was surprised by how good this instant coffee tastes. Perfect for when I need a quick caffeine fix. Will definitely buy again."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Kettle",
        price: 55,
        disprice: 45,
        stock: 0,
        content: "Boil water quickly and efficiently with our premium Kettle. Featuring a sleek, modern design, this kettle is perfect for making tea, coffee, or other hot beverages. With its fast-heating element and ergonomic handle, it offers both style and functionality in one convenient appliance.",
        description: "Our Kettle is built with a high-quality stainless steel body, ensuring durability and longevity. The cordless design and 360-degree swivel base make it easy to pour without any hassle. Its automatic shut-off feature ensures safety, while the large capacity allows you to brew multiple cups at once, making it ideal for family use or entertaining guests.",
        category: ["Coffee Accessories", "Coffee Equipment"],
        tags: ["Kettle", "Set", "Mug"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Stainless Steel" },
            { id: 2, title: "Capacity", content: "1.7L" },
            { id: 3, title: "Power", content: "1500W" },
            { id: 4, title: "Features", content: "Auto Shut-Off, Boil Dry Protection" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Emily White",
                date: "Apr 15, 2024",
                rating: 5,
                content: "Love this kettle! It boils water quickly and looks great on my countertop. The auto shut-off is a nice safety feature."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Oliver Brown",
                date: "Apr 16, 2024",
                rating: 5,
                content: "This kettle is fantastic! It’s fast, easy to use, and the design is very sleek. Highly recommend it to anyone in need of a reliable kettle."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Coffee Bottle",
        price: 30,
        disprice: 25,
        stock: 15,
        content: "Keep your coffee hot or cold for hours with our Coffee Bottle. Designed for coffee lovers on the go, it features double-wall insulation to maintain the perfect temperature. Whether you're commuting, traveling, or at the gym, this bottle ensures your coffee stays fresh and flavorful all day long.",
        description: "Crafted from high-quality stainless steel, our Coffee Bottle is both durable and stylish. The leak-proof design and wide-mouth opening make it easy to fill, pour, and clean. The vacuum insulation keeps your coffee hot for up to 12 hours or cold for 24, providing the ultimate solution for coffee enthusiasts with a busy lifestyle.",
        category: ["Coffee Accessories", "Coffee Equipment"],
        tags: ["Bottle", "Set", "Mug"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Stainless Steel" },
            { id: 2, title: "Capacity", content: "500ml" },
            { id: 3, title: "Insulation", content: "Vacuum Sealed" },
            { id: 4, title: "Temperature Retention", content: "12 Hours Hot, 24 Hours Cold" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Lucas Gray",
                date: "Apr 18, 2024",
                rating: 5,
                content: "This coffee bottle is a game changer! It keeps my coffee hot all day, even when I'm running errands. Super convenient and stylish."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Ava Johnson",
                date: "Apr 19, 2024",
                rating: 5,
                content: "Perfect for my morning commute. It holds the right amount of coffee and keeps it warm until I get to work. Love it!"
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Coffee Blend",
        price: 42,
        disprice: 35,
        stock: 8,
        content: "Indulge in the rich, balanced flavor of our Coffee Blend. This carefully crafted blend combines the finest beans from around the world to create a smooth, aromatic coffee experience. Perfect for your daily brew, our Coffee Blend delivers a satisfying cup every time, whether you're using a drip machine, French press, or espresso maker.",
        description: "Our Coffee Blend features a harmonious mix of beans sourced from Colombia, Brazil, and Ethiopia. Each batch is expertly roasted to highlight the natural flavors and create a rich, full-bodied cup. The blend is perfect for coffee lovers who enjoy a medium roast with a mild, well-rounded taste that’s not too bold but full of flavor.",
        category: ["Coffee Beans", "Coffee Set"],
        tags: ["Blend", "Beans", "Instant"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Origin", content: "Colombia, Brazil, Ethiopia" },
            { id: 2, title: "Roast Level", content: "Medium" },
            { id: 3, title: "Blend Type", content: "Arabica and Robusta" },
            { id: 4, title: "Weight", content: "250g" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Jackie Patel",
                date: "Apr 20, 2024",
                rating: 5,
                content: "This Coffee Blend is perfect! It’s got just the right amount of richness and smoothness. I drink it every morning and it’s always a great start to my day."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Ethan Clarke",
                date: "Apr 21, 2024",
                rating: 5,
                content: "A fantastic blend that hits all the right notes. Smooth, flavorful, and perfectly balanced. Highly recommend for anyone who enjoys a medium roast."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Coffee Kit",
        price: 60,
        disprice: 50,
        stock: 10,
        content: "Everything you need to brew the perfect cup is included in our Coffee Kit. This comprehensive set features premium coffee beans, a high-quality grinder, and all the accessories you need to elevate your coffee brewing experience. Whether you're a beginner or a seasoned barista, this kit ensures you have all the tools to create café-quality coffee at home.",
        description: "Our Coffee Kit includes freshly roasted coffee beans, a manual grinder for the perfect grind, a pour-over coffee maker, and a coffee scoop. Each component is selected for its quality and ease of use, designed to enhance the flavor of your coffee and improve your brewing technique. It's the ideal gift for coffee lovers or anyone who wants to take their coffee game to the next level.",
        category: ["Coffee Set", "Coffee Accessories"],
        tags: ["Set", "Mug", "Blend"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Kit Includes", content: "Coffee Beans, Manual Grinder, Pour-Over Maker" },
            { id: 2, title: "Grind Type", content: "Adjustable" },
            { id: 3, title: "Brewing Method", content: "Pour-Over" },
            { id: 4, title: "Weight", content: "450g" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Sophia Lee",
                date: "Apr 22, 2024",
                rating: 5,
                content: "I absolutely love this Coffee Kit! The grinder is easy to use, and the pour-over maker gives my coffee such a smooth taste. Highly recommend this kit to anyone who wants to enjoy freshly brewed coffee at home."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Noah Harris",
                date: "Apr 23, 2024",
                rating: 5,
                content: "This kit has everything you need for the perfect cup of coffee. The beans are excellent, and the grinder is top-notch. It's been a game-changer for my morning routine!"
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Filter Handle",
        price: 25,
        disprice: 20,
        stock: 18,
        content: "Enhance your brewing experience with our durable Filter Handle. Designed for precision and ease, this handle is perfect for holding your coffee filter while you brew. With its ergonomic design and sturdy construction, it ensures a comfortable and secure grip, making it the ideal tool for any coffee lover.",
        description: "Crafted from high-quality materials, our Filter Handle provides a reliable and safe grip for your coffee filter during the brewing process. It fits most standard coffee filter sizes and is designed for easy cleaning and long-lasting use. The handle is heat-resistant, ensuring that you can handle your filter without any discomfort, even when hot water is in use.",
        category: ["Coffee Equipment", "Coffee Maker"],
        tags: ["Espresso", "Set", "Portafilter"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Heat-Resistant Plastic" },
            { id: 2, title: "Compatibility", content: "Fits Most Filters" },
            { id: 3, title: "Weight", content: "150g" },
            { id: 4, title: "Dimensions", content: "20cm x 5cm" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Liam Turner",
                date: "Apr 24, 2024",
                rating: 5,
                content: "This Filter Handle is a lifesaver! It makes handling the filter so much easier, especially when dealing with hot water. It’s sturdy, and I can tell it will last for a long time."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Olivia Brooks",
                date: "Apr 25, 2024",
                rating: 5,
                content: "Perfect addition to my coffee setup. The handle feels comfortable and secure, and it’s super easy to clean. Highly recommend it to anyone who loves pour-over coffee."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Moka Pot",
        price: 45,
        disprice: 38,
        stock: 12,
        content: "Brew authentic Italian coffee with our Moka Pot. Designed to create rich, bold coffee, the Moka Pot uses steam pressure to force water through the ground coffee, delivering a full-bodied espresso-like drink. It’s the perfect tool for coffee aficionados who appreciate the art of stovetop brewing.",
        description: "Made from high-quality aluminum, our Moka Pot is durable and easy to use. It features a heat-resistant handle and a secure safety valve for worry-free brewing. With its classic design, it allows you to create the perfect espresso-style coffee right on your stovetop. It’s available in various sizes to suit your brewing needs, from solo cups to larger pots for friends and family.",
        category: ["Coffee Maker", "Coffee Equipment"],
        tags: ["Moka", "Set", "Espresso"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Aluminum" },
            { id: 2, title: "Capacity", content: "6 Cups" },
            { id: 3, title: "Brewing Style", content: "Stovetop Espresso" },
            { id: 4, title: "Weight", content: "500g" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Eva Collins",
                date: "Apr 26, 2024",
                rating: 5,
                content: "The Moka Pot brews the most amazing coffee! It’s super easy to use and makes a strong, rich cup. I love the authentic Italian taste it gives my coffee every morning."
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "John Richards",
                date: "Apr 27, 2024",
                rating: 5,
                content: "This Moka Pot is fantastic. It’s well-built, heats up quickly, and delivers the perfect cup of coffee. I highly recommend it to anyone looking for a stovetop espresso maker."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Espresso Machine",
        price: 150,
        disprice: 130,
        stock: 6,
        content: "Elevate your coffee experience with our high-performance Espresso Machine. Designed for coffee enthusiasts, this machine brings professional-grade espresso brewing right to your kitchen. With adjustable settings for temperature, pressure, and grind size, it lets you customize your coffee to your exact preferences, making it perfect for both novice brewers and seasoned baristas.",
        description: "Our Espresso Machine features a sleek, stainless-steel design and advanced brewing technology. Equipped with a built-in grinder and a steam wand, it allows you to brew espresso, lattes, and cappuccinos with ease. The programmable features ensure that each cup is brewed to perfection, while the large water tank reduces the need for constant refills. Whether you're making a single shot or multiple, this espresso machine has you covered.",
        category: ["Coffee Maker", "Coffee Equipment"],
        tags: ["Espresso", "Maker", "Set"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Stainless Steel" },
            { id: 2, title: "Capacity", content: "1.5L Water Tank" },
            { id: 3, title: "Power", content: "1200W" },
            { id: 4, title: "Weight", content: "6kg" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Lily Morgan",
                date: "Apr 28, 2024",
                rating: 5,
                content: "This espresso machine is a game-changer! It’s easy to use, and the quality of the espresso is unbeatable. I love making lattes and cappuccinos with it every morning!"
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Mason Scott",
                date: "Apr 29, 2024",
                rating: 5,
                content: "I’ve tried a lot of espresso machines, and this one is by far the best. It’s sturdy, reliable, and brews an amazing cup of coffee. Worth every penny!"
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Coffee Mug",
        price: 15,
        disprice: 12,
        stock: 25,
        content: "Start your day with a perfect brew in our Coffee Mug. Crafted from high-quality ceramic, this mug features a classic design that keeps your coffee warm and your hands comfortable. With a large capacity and sturdy handle, it’s the ideal mug for your morning routine, whether you're enjoying a quick cup or settling in for a long sip.",
        description: "Made from durable ceramic, our Coffee Mug is designed to retain heat, allowing you to savor your beverage longer. The smooth, glossy finish gives it a sleek look, while the ergonomic handle ensures a comfortable grip. This mug is microwave and dishwasher safe, making it both practical and stylish for everyday use. Perfect for home, office, or as a thoughtful gift for coffee lovers.",
        category: ["Coffee Accessories", "Coffee Equipment"],
        tags: ["Mug", "Set", "Blend"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Ceramic" },
            { id: 2, title: "Capacity", content: "350ml" },
            { id: 3, title: "Microwave Safe", content: "Yes" },
            { id: 4, title: "Dishwasher Safe", content: "Yes" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Grace Wilson",
                date: "Apr 30, 2024",
                rating: 5,
                content: "I love this mug! It’s the perfect size for my morning coffee, and it keeps it warm for longer than any other mug I’ve used. The handle is comfortable, too!"
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Ethan Cooper",
                date: "May 1, 2024",
                rating: 5,
                content: "This is my go-to coffee mug now. The design is simple but elegant, and it holds just the right amount of coffee. It’s also super easy to clean in the dishwasher!"
            }
        ]
    }

];

export default products;